import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Input as ChakraInput,
  InputGroup,
  InputLeftElement,
  InputProps as ChakraInputProps,
  InputRightAddon,
  InputRightElement,
  useBoolean,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  ElementType,
  forwardRef,
  ForwardRefRenderFunction,
  useState,
} from 'react';
import { FieldError } from 'react-hook-form';
import { LuEye, LuEyeClosed } from 'react-icons/lu';
import { IMaskInput } from 'react-imask';

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  error?: FieldError;
  leftIcon?: ElementType;
  mask?: any;
  strength?: any;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, label, error = null, leftIcon, mask, strength, type, ...rest },
  ref,
) => {
  const color = useColorModeValue('gray.700', 'white');
  const colorIcon = useColorModeValue('blue.500', 'white');
  const colorInput = useColorModeValue('gray.700', 'white');

  const [typePassword] = useState(type === 'password');
  const [visiblePassword, setVisiblePassword] = useBoolean();

  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel
          color={color}
          fontSize="sm"
          fontWeight="light"
          htmlFor={name}
        >
          {label}
        </FormLabel>
      )}

      {/* erro vai aparecer em cima do tipo pra senha com força */}
      {!!error && strength && (
        <FormErrorMessage>{error.message}</FormErrorMessage>
      )}

      <InputGroup>
        {!!leftIcon && (
          <InputLeftElement
            pointerEvents="none"
            children={
              <Icon
                as={leftIcon}
                color={colorIcon}
                fontSize={20}
                mt="2"
                ml="2"
              />
            }
          />
        )}
        <ChakraInput
          as={mask ? IMaskInput : undefined}
          mask={mask}
          // inputRef={mask ? ref : undefined}
          ref={ref}
          id={name}
          name={name}
          type={visiblePassword ? 'text' : type}
          fontWeight="light"
          fontSize="md"
          color={colorInput}
          size="lg"
          rounded="2xl"
          // borderBottomRadius="0px"
          {...rest}
          sx={{
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus':
              {
                WebkitBoxShadow: 'transparent !important',
                WebkitTextFillColor: `${colorInput} !important`,
                transition: 'background-color 9999s ease-in-out 0s',
              },
          }}
        />
        {typePassword && (
          <InputRightElement
            children={
              <Icon
                as={!visiblePassword ? LuEyeClosed : LuEye}
                color={colorIcon}
                cursor="pointer"
                fontSize={20}
                mt="2"
                mr="2"
                onClick={setVisiblePassword.toggle}
              />
            }
          />
        )}
      </InputGroup>

      {!!error && !strength && (
        <FormErrorMessage>{error.message}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export const Input = forwardRef(InputBase);
